import { DocumentNode } from 'apollo-link';

import gql from 'graphql-tag';
import { TablesDisplayGridRowDataFragmentGql } from './TablesDisplayGridRowDataFragmentGql';

export const TablesByTagQueryGql: DocumentNode = gql`
query TablesByTagQuery(
  $tagName: String!,
  $first: Int!,
  $offset: Int!,
  $textSearch: String,
  $orderBy: DatabaseTableSortOrder!,
  $hasActiveWarning: Boolean,
  $isCertified: Boolean,
  $publishedConnectionsLineageEnabled: Boolean!
) {
  tags(filter: {name: $tagName}) {
    databaseTablesConnection(
      first: $first,
      offset: $offset,
      orderBy: $orderBy,
      filter: {
        hasActiveWarning: $hasActiveWarning,
        isCertified: $isCertified,
        text: $textSearch
      },
      permissionMode: FILTER_RESULTS
    ) {
      totalCount
      nodes {
        ...TablesDisplayGridRowDataFragment
        tags {
          name
        }
      }
    }
    maxDownstreamDatasources: databaseTablesConnection(
      filter: {
        hasActiveWarning: $hasActiveWarning,
        isCertified: $isCertified,
        text: $textSearch
      }
      orderBy: { field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC }
      first: 1,
      permissionMode: FILTER_RESULTS
    ) {
      nodes {
        downstreamDatasourcesConnection { totalCount }
      }
    }
    maxDownstreamWorkbooks: databaseTablesConnection(
      filter: {
        hasActiveWarning: $hasActiveWarning,
        isCertified: $isCertified,
        text: $textSearch
      }
      orderBy: { field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC }
      first: 1,
      permissionMode: FILTER_RESULTS
    ) {
      nodes {
        downstreamWorkbooksConnection { totalCount }
      }
    }
  }
}
${TablesDisplayGridRowDataFragmentGql}
`;
